/**
 * Solwe's JavaScript for this store. Loaded as a module from layout/theme.liquid.
 * Extends the theme's own events; never forks assets/theme.js.liquid.
 * Every block is named and points at its CUSTOMIZATIONS.md entry.
 */

/* SOLWE: StockQ button sync - CUSTOMIZATIONS.md #3 */
// StockQ (Restock Rocket) redraws its "Ilmoita, kun saatavilla" button on every
// variant change, but decides whether to show it from the PREVIOUS variant's
// availability. Moving from an available variant to a sold-out one leaves the
// button out, and the reverse shows it on an available variant. StockQ's own
// state (window._RestockRocketConfig.selected_variant_*) is already correct by
// then, so we only ask it to redraw once its own handler has finished.
// renderButtonForVariant() adds the button for a sold-out variant and removes it
// for an available one, so no availability logic is duplicated here.
document.addEventListener("variant:change", (event) => {
  const variant = event.detail?.variant;
  const stoq = window._RestockRocket;

  if (!variant || typeof stoq?.renderButtonForVariant !== "function") {
    return;
  }

  // Main product only. Quick buy and recommendation forms fire the same event.
  if (event.detail.product?.id !== window._RestockRocketConfig?.product?.id) {
    return;
  }

  setTimeout(() => stoq.renderButtonForVariant(variant.id), 0);
});
/* /SOLWE */
